import { ethers } from 'ethers';

const networks = {
    mainnet: {
        contractAddress: '0x0e4fb5B3f960d1E33B7f9E324c1e44D94c887B98',
        networkName: 'Ethereum Mainnet',
        explorerUrl: 'https://etherscan.io/tx/',
        openSeaUrl: 'https://opensea.io/account',
        networkParams: {
            chainId: '0x1'
        },
    },
    rinkeby: {
        contractAddress: '0x909B9469E5CDf1A3bd8Fe4fF08F19526095485b3',
        networkName: 'Ethereum Mainnet',
        explorerUrl: 'https://rinkeby.etherscan.io/tx/',
        openSeaUrl: 'https://testnets.opensea.io/account',
        networkParams: {
            chainId: '0x4'
        },
    },
}

const config = {
    ...networks.mainnet,
    contractABI: [
        `function getContractInfo(address target) external view returns (
                uint256 _currentStage,
                uint256 _maxTokensAllowed,
                uint256 _tokenPrice,
                uint256 _soldAmount,
                uint256 _purchasedAmount,
                uint256 _presaleTotalLimit,
                bool _isWhitelisted,
                uint256 _totalForSale
            )`,
        'function mint(uint256 _amount, address _recipient) external payable',
    ]
}

let walletProvider = null;
let walletConnector = null;
let chosenWallet = "";

function setupModals() {
    var closeButtons = document.querySelectorAll('.nft-js-modal-close, .nft-js-modal-overlay');

    for (var i = 0; i < closeButtons.length; i++) {
        const b = closeButtons[i];
        b.onclick = function () {
            b.closest('.nft-modal').classList.remove('open');
        }
    }
}

async function verifyWalletConnect() {
    return new Promise(resolve => {
        window.connect();
        window.wcConnectPromiseResolve = (v) => {
            console.log('wcConnectPromiseResolve called');
            resolve(v);
            window.wcConnectPromiseResolve = undefined;
        };
    });
}

async function verifyMetamask() {
    if (!chosenWallet) {
        // todo guess wallet if connected already
        return false;
    }

    const walletName = chosenWallet == 'metamask' ? 'MetaMask' : 'Coinbase Wallet';

    if (!window.ethereum) {
        alert(`Please install ${walletName} to interact with this feature`);
        return;
    }

    if (chosenWallet == 'metamask') {
        walletProvider = window.ethereum.providers ? window.ethereum.providers.find((provider) => provider.isMetaMask) : window.ethereum;
    } else if (chosenWallet == 'coinbase') {
        walletProvider = window.ethereum.providers ? window.ethereum.providers.find((provider) => !provider.isMetaMask) : window.ethereum;
    } else {
        throw new Error('Unknown wallet provider');
    }

    let accounts;
    try {
        if (getChainId() != config.networkParams.chainId) {
            try {
                await walletProvider.request({
                    method: 'wallet_switchEthereumChain',
                    params: [{
                        chainId: config.networkParams.chainId
                    }],
                });
            } catch {
                await window.ethereum.request({ method: 'wallet_addEthereumChain', params: [config.networkParams] });
            }
            await new Promise(resolve => setTimeout(resolve, 750));
        }

        const params = [config.networkParams];
        accounts = await walletProvider.request({
            method: 'eth_requestAccounts'
        });

        if (getChainId() != config.networkParams.chainId) {
            console.log(`Please switch ${walletName} network to ${config.networkName}`);
            return;
        }
    } catch (error) {
        if (error.code == -32002) {
            alert(`Please open your ${walletName} and select an account`);
            return;
        } else if (error.code == 4001) {
            console.log(`Transacrion rejected`);
            return;
        } else if (error.code) {
            throw error;
        }
    }
    return accounts[0];
}

async function verifyWalletConnection() {
    if (chosenWallet === 'walletconnect') {
        return verifyWalletConnect();
    } else {
        return verifyMetamask();
    }
}

// async function connectButtonOnClick() {
//     chosenWallet = await chooseWallet();

//     if (!await verifyWalletConnection()) {
//         return;
//     }
//     console.log("Works");
//     contract = new ethers.Contract(config.contractAddress, config.contractABI, getProvider());
//     await fetchContractState();
//     await updateContractState();
// }

let contractState = null;
let currentSelectedAmount = 1;

async function fetchContractState() {
    displayMessage('Fetching contract info', {showLoading:true});
    const contract = new ethers.Contract(config.contractAddress, config.contractABI, getProvider());

    const result = await contract.getContractInfo(getAddress());
    const [
        currentStage,
        maxTokensAllowed,
        tokenPrice,
        soldAmount,
        purchasedAmount,
        presaleTotalLimit,
        isWhitelisted,
        totalForSale
    ] = result;

    contractState = {
        currentStage,
        maxTokensAllowed,
        tokenPrice,
        soldAmount,
        purchasedAmount,
        presaleTotalLimit,
        isWhitelisted,
        totalForSale
    };

    closeMessageModal();
}

function closeMessageModal() {
    var modalWindow = document.querySelector('.nft-modal.loading-modal');
    modalWindow.classList ? modalWindow.classList.remove('open') : modalWindow.className = modalWindow.className.replace(new RegExp('(^|\\b)' + 'open'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
}

function closeMintModal() {
    var modalWindow = document.querySelector('.nft-modal.nft-mint-modal');
    modalWindow.classList ? modalWindow.classList.remove('open') : modalWindow.className = modalWindow.className.replace(new RegExp('(^|\\b)' + 'open'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
}

function displayMessage(msg, { showLoading = false, showX = false } = {}) {
    const modal = document.querySelector('.nft-modal.loading-modal');
    modal.classList.add('open');

    const modalContainer = modal.querySelector('.nft-modal-container');

    modalContainer.innerHTML = `
        <header class="chakra-modal__header css-pscz1k" id="HEADER_3">
                    <div class="css-vxg2jq" id="DIV_4">
                        <div class="css-aix3sy" id="DIV_5">
                            <p class="chakra-text css-11t0pik" id="P_6">
                                ${msg}<br><br>${showLoading ? `
      <svg height="32" width="32">
        <circle cx="16" cy="16" fill="none" r="14" stroke="#34C77B" stroke-dasharray="87.96459430051421" stroke-dashoffset="74.76990515543707" stroke-width="4" class="nft-modal-stage-loading"></circle>
      </svg>` : ''}
                            </p>
                        </div>
                        ${showX ? `<div class="css-0" id="DIV_9">
                        </div>` : ''}
                        
                    </div>
                </header>`;
    setupModals();
}

async function sendTransactionWrapper() {
    if (currentSelectedAmount == 0) {
        return;
    }
    let txHash;
    const provider = getProvider();
    const mintAmount = currentSelectedAmount;

    await fetchContractState();
    const requiredAmount = contractState.tokenPrice.mul(mintAmount);

    const hbal = await provider.getBalance(getAddress());
    if (requiredAmount.gt(ethers.BigNumber.from(hbal))) {

        return alert(
            `Not enough balance. You need ${ethers.utils.formatEther(
                requiredAmount
            )} ETH to mint ${mintAmount} NFT${mintAmount > 1 ? 's' : ''}.`
        );
    }

    const iface = new ethers.utils.Interface(config.contractABI);
    const params = iface.encodeFunctionData('mint', [
        ethers.utils.hexlify(mintAmount),
        getAddress()
    ]);

    txHash = await sendTransaction([
        {
            from: getAddress(),
            to: config.contractAddress,
            value: requiredAmount.toHexString().replace(/^0x0+(?=\d)/, '0x'),
            data: params
        }]);

    displayMessage(`
            Transaction submitted. Please wait for confirmation.
            <br>
            Transaction hash: <br> ${txHash}
            <br>
            <a target="_blank" href="${config.explorerUrl}${txHash}">View on EtherScan</a>
            `, { showLoading: true }
    );
    // const tx = await provider.getTransaction(txHash);
    // const txReceipt = await tx.wait();
    const tm = await getProvider().waitForTransaction(txHash);
    console.log('transaction mined', tm);
    displayMessage(`
            NFTs succesfully minted!
                <br>
                Transaction hash: ${txHash}
                <br>
                <a target="_blank" href="${config.explorerUrl}${txHash}">View on EtherScan</a>
                <br>
                <a target="_blank" href="${config.openSeaUrl}">
                    View your NFTs on OpenSea
                </a>
            `
    );
    // await fetchContractState();
    // await updateContractState();
    closeMintModal();
}

async function updateContractState() {
    async function checkIfMintingAvailable() {
        if (contractState.currentStage.eq(0)) {
            return displayMessage('NFTs not for sale yet. <br>Please wait for the pre-sale.');
        }

        if (contractState.currentStage.eq(1) && contractState.isWhitelisted == 0) {
            return displayMessage('You are not whitelisted. <br>Please wait for the public sale.');
        }

        if (contractState.currentStage.eq(1) && contractState.soldAmount == contractState.presaleTotalLimit) {
            return displayMessage('Pre-sale sold out. Please wait for the public sale.');
        }

        if (contractState.soldAmount == contractState.totalForSale) {
            return displayMessage('Sold out.');
        }

        if (!contractState.purchasedAmount.eq(0) && contractState.maxTokensAllowed.eq(0)) {
            return displayMessage(`
                    You already purchased ${contractState.purchasedAmount} NFT${contractState.purchasedAmount > 1 ? 's' : ''}.
                `);
        }

        if (contractState.maxTokensAllowed == 0) {
            return displayMessage('Error: Cannot mint. Please try again later.');
        }

        return true;
    }

    if (!await checkIfMintingAvailable()) {
        return;
    }

    let transacting = false;

    // remove event listeners...
    var old_element = document.querySelector('#nft-mint-button');
    var new_element = old_element.cloneNode(true);
    old_element.parentNode.replaceChild(new_element, old_element);
    new_element.addEventListener('click', async (ev) => {

        if (currentSelectedAmount == 0) {
            return;
        }

        ev.preventDefault();
        if (transacting) {
            return;
        }
        transacting = true;

        try {
            await fetchContractState();
            if (!await checkIfMintingAvailable()) {
                return;
            }

            await sendTransactionWrapper('mint');

        } finally {
            transacting = false;
        }
    });

    setupMintWidget();
}

let isMintWidgetSetUp = false;
function setupMintWidget() {
    if (isMintWidgetSetUp) {
        const modal = document.querySelector('.nft-modal.nft-mint-modal');
        modal.classList.add('open');
        return;
    }
    isMintWidgetSetUp = true;

    const mintAmountText = document.querySelector('#nft-mint-amount-text');

    function setMintAmount(amount) {
        if (amount > contractState.maxTokensAllowed) {
            amount = contractState.maxTokensAllowed;
        }

        if (amount < 1) {
            amount = 1;
        }

        mintAmountText.innerHTML = amount;
        currentSelectedAmount = +amount;
    }

    function getMintAmount() {
        const mintAmountText = document.querySelector('#nft-mint-amount-text');
        return parseInt(mintAmountText.innerHTML);
    }

    document.querySelector('#nft-mint-amount-minus').addEventListener('click', ev => {
        ev.preventDefault();
        setMintAmount(getMintAmount() - 1);
    });

    document.querySelector('#nft-mint-amount-plus').addEventListener('click', ev => {
        ev.preventDefault();
        setMintAmount(getMintAmount() + 1);
    });

    const modal = document.querySelector('.nft-modal.nft-mint-modal');
    modal.classList.add('open');
}

function getProvider() {
    if (chosenWallet === 'coinbase' || chosenWallet === 'metamask') {
        return new ethers.providers.Web3Provider(walletProvider);
    } else {
        return new ethers.providers.JsonRpcProvider(config.alchemyUri);
    }
}

function getAddress() {
    if (chosenWallet === 'metamask' || chosenWallet === 'coinbase') {
        return walletProvider.selectedAddress;
    } else if (chosenWallet === 'walletconnect') {
        return walletConnector.accounts[0];
    } else {
        return '';
    }
}

function getChainId() {
    if (chosenWallet === 'metamask' || chosenWallet === 'coinbase') {
        return walletProvider.chainId;
    } else if (chosenWallet === 'walletconnect') {
        return walletConnector.chainId;
    } else {
        throw new Error('Unknown wallet provider');
    }
}

async function sendTransaction(params) {
    try {
        if (chosenWallet === 'walletconnect') {
            displayMessage('Please confirm the transaction in your wallet.', {showLoading:true});
            return await walletConnector.sendTransaction(params[0]);
        } else if (chosenWallet === 'metamask') {
            displayMessage('Please confirm the transaction in your wallet.', {showLoading:true});
            return await getProvider().send('eth_sendTransaction', params);
        } else if (chosenWallet === 'coinbase') {
            displayMessage('Please confirm the transaction in your wallet.', {showLoading:true});
            return await getProvider().send('eth_sendTransaction', params);
        } else {
            throw new Error('Unrecognized wallet')
        }    
    } catch (e) {
        closeMessageModal();
        throw e;
    }
}

function elFromHtml([html]) {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    return template.content.firstChild;
}

let initialized = false;
function initialize() {
    if (initialized) {
        return;
    }
    initialized = true;

    console.log('initializing')

    document.body.appendChild(elFromHtml`
        <div style="z-index: 99999999;" class="chakra-modal__content-container nft-modal loading-modal css-1yb2anq" id="DIV_1">
            <div class="nft-modal-overlay nft-js-modal-overlay"></div>

            <section class="nft-modal-container chakra-modal__content css-59quxq" id="SECTION_2">      
                
                
            </section>
        </div>
	
    `);

    document.body.appendChild(elFromHtml`
    <div class="nft-modal nft-mint-modal">
        <div class="nft-modal-overlay nft-js-modal-overlay"></div>
        <div class="nft-modal-container">
        <div class="nft-modal-header">
<div class="nft-modal-title">How many NFTs will you mint?</div>
<div class="nft-modal-close nft-js-modal-close">&#10005;</div>
</div>
        
        <div class="nft-modal-content">
        <div id="nft-mint-amount-input-container">
        <svg id="nft-mint-amount-minus"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 490 490" style="enable-background:new 0 0 490 490;" xml:space="preserve"> <g> <path d="M52.8,311.3c-12.8-12.8-12.8-33.4,0-46.2c6.4-6.4,14.7-9.6,23.1-9.6s16.7,3.2,23.1,9.6l113.4,113.4V32.7   c0-18,14.6-32.7,32.7-32.7c18,0,32.7,14.6,32.7,32.7v345.8L391,265.1c12.8-12.8,33.4-12.8,46.2,0c12.8,12.8,12.8,33.4,0,46.2   L268.1,480.4c-6.1,6.1-14.4,9.6-23.1,9.6c-8.7,0-17-3.4-23.1-9.6L52.8,311.3z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
        <svg id="nft-mint-amount-plus" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 490 490" style="enable-background:new 0 0 490 490;" xml:space="preserve"> <g> <path d="M52.8,311.3c-12.8-12.8-12.8-33.4,0-46.2c6.4-6.4,14.7-9.6,23.1-9.6s16.7,3.2,23.1,9.6l113.4,113.4V32.7   c0-18,14.6-32.7,32.7-32.7c18,0,32.7,14.6,32.7,32.7v345.8L391,265.1c12.8-12.8,33.4-12.8,46.2,0c12.8,12.8,12.8,33.4,0,46.2   L268.1,480.4c-6.1,6.1-14.4,9.6-23.1,9.6c-8.7,0-17-3.4-23.1-9.6L52.8,311.3z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
        <div  style="pointer-events: none;"><div id="nft-mint-amount-text">1</div>
        </div>
        <div style="display: flex;  justify-content: center;">
        <button id="nft-mint-button" class="header-join-btn row">Mint</button>
        </div>
        </div>
        
        </div>
    </div>
  `);

    document.body.appendChild(elFromHtml`<style>
    .nft-wallet-option-style {
        cursor: pointer;
    }
    
    .nft-wallet-option-style:hover {
        background: rgba(255, 255, 255, 0.16) !important;
    }
    
    .walletconnect-modal__base {
        max-width: 400px !important;
    }
    
    .nft-input-el {
        width: calc(100% - 12px);
        height: calc(100% - 12px);
        padding: 5px;
        margin: 0;
        font-size: 18px;
    }
    
    
    .wallet-alternative {
        width: 80%;
        height: 40px;
        padding-top: 3%;
        padding-bottom: 3%;
        padding-left: 3%;
        padding-right: 3%;
        vertical-align: top;
        display: inline-block;
        border: 1px solid #ccc;
        /* border-radius: 5px; */
        cursor: pointer;
        margin-top: 2px;
        margin-bottom: 2px;
    }
    
    .wallet-alternative:hover {
        background-color: #f5f5f5;
    }
    
    .wallet-alternative img {
        height: 100%;
        float: left;
        display: inline;
    }
    
    .wallet-alternative .wallet-alternative-name {
        padding-left: 25px;
    }
    
    #nft-mint-amount-text {
        color: black;
        display: block;
        margin: auto;
        width: 300px;
        max-width: 100%;
        height: 45px;
        line-height: 45px;
        font-size: 35px;
        text-align: center;
        margin-bottom: 20px;
        /* border-radius: 5px; */
        -webkit-user-select: none; /* Safari */        
-moz-user-select: none; /* Firefox */
-ms-user-select: none; /* IE10+/Edge */
user-select: none; /* Standard */
    }
    
    #nft-mint-amount-input-container {
        margin: 0 auto;
        width: 310px;
        position: relative;
    }
    
    #nft-mint-amount-minus {
        transform: rotate(90deg);
        height: 20px;
        position: absolute;
        left: 0;
        top: 0;
        padding: 15px;
        cursor: pointer;
        box-sizing: revert;
    }
    
    #nft-mint-amount-plus {
        transform: rotate(-90deg);
        height: 20px;
        position: absolute;
        right: 0;
        top: 0;
        padding: 15px;
        cursor: pointer;
        box-sizing: revert;
    }
    
    @media (max-width: 768px) {
        #nft-mint-amount-input {
            width: 190px;
        }
    
        #nft-mint-amount-input-container {
            width: 200px;
        }
    
        .wallet-alternative .wallet-alternative-name {
            font-size: 0.7rem;
        }
    }
    
    .nft-modal,
    .chakra-modal__content-container {
        position: fixed;
        top: 46px;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 20;
        padding: 30px;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        opacity: 0;
        visibility: hidden;
        transition: visibility 0s linear 0.1s, opacity 0.3s ease;
        z-index: 1000000;
    }
    
    .nft-modal.open {
        visibility: visible;
        opacity: 1;
        transition-delay: 0s;
    }
    
    .nft-modal-title {
        padding-left: 10px;
        color: black;
        
        -webkit-user-select: none; /* Safari */        
-moz-user-select: none; /* Firefox */
-ms-user-select: none; /* IE10+/Edge */
user-select: none; /* Standard */
    }
    
    .nft-modal-header {
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 30px;
        padding-right: 30px;
        font-size: 2em;
        border-bottom: 1px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .nft-modal-content {
        display: inline-block;
        margin: 20px;
        padding-left: 20px;
        padding-right: 20px;
        /* min-width: 500px; */
        max-width: 100%;
    
        /* border-radius: 10px; */
        /* border: 1px solid #ccc; */
    }
    
#nft-mint-button {
    width: 100px;
    
    -webkit-user-select: none; /* Safari */        
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
}

    .nft-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 21;
        background-color: rgba(0, 0, 0, 0.7);
    }
    
    .nft-modal-close {
        cursor: pointer;

        
        -webkit-user-select: none; /* Safari */        
-moz-user-select: none; /* Firefox */
-ms-user-select: none; /* IE10+/Edge */
user-select: none; /* Standard */
    }
    
    .nft-modal-close:hover {
        background: rgba(255, 255, 255, 0.06) !important;
    }
    
    .nft-modal-container {
        position: relative;
        z-index: 22;
        width: auto;
        max-width: 700px;
        top: 35%;
        transform: translateY(-50%);
        box-shadow: 0 0 10px #fff;
        margin: 0 auto;
        background-color: #fff;
        text-align: center;
        /* border-radius: 10px; */
        
    }
    
    .nft-modal-stage-loading {
        animation: 0.75s linear 0s infinite normal none running rotate;
        transform-origin: 16px 16px;
    }
    
    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
    
        100% {
            transform: rotate(360deg);
        }
    }
    
    input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    
    .nft-q-button-active {
        background-color: #ffffff !important;
        background-image: none !important;
        color: #000000 !important;
    }
    
    .nft-q-button-disabled {
        cursor: not-allowed !important;
    }
    
    [data-id^="nft-mint-quantity-"],
    [data-id="nft-connect-wallet-button-center"],
    [data-id="nft-connect-wallet-button"],
    [data-id="nft-mint-button"],
    [data-id="nft-buy-with-credit-card"],
    [data-id="nft-mint-amount-minus"],
    [data-id="nft-mint-amount-plus"],
    [data-id="nft-mint-amount-plus-10"],
    [data-id="nft-mint-amount-plus-50"] {
        cursor: pointer;
    }
    
    .choose-wallet-modal .nft-modal-container {
        text-align: left;
    }
    
    #DIV_13,
    #DIV_13>div,
    #DIV_13>div>div,
    #DIV_13>div>div>div {
        max-width: 100%;
    }
    
    .nft-modal-container.chakra-modal__content {
        max-width: 100vw !important;
    }
    
    #DIV_4,
    #SECTION_2 {
        background: #171923;
        display: flex
    }
    
    #DIV_29,
    #DIV_5,
    #P_30,
    #P_6 {
        block-size: 27px
    }
    
    #MSVG_1,
    #MSVG_2 {
        border-width: 0;
        overflow-wrap: break-word
    }
    
    #A_32,
    #path_12,
    #path_8 {
        transform-origin: 0 0
    }
    
    #DIV_16,
    #DIV_22,
    #DIV_5,
    #P_6 {
        inline-size: 402px
    }
    
    #DIV_17,
    #DIV_20,
    #DIV_23,
    #DIV_26 {
        perspective-origin: 0 10.8px;
        min-width: auto
    }
    
    .css-18gkurw {
        outline: transparent solid 2px;
        outline-offset: 2px;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        flex-shrink: 0;
        width: var(--close-button-size);
        height: var(--close-button-size);
        border-radius: var(--chakra-radii-md);
        transition-property: var(--chakra-transition-property-common);
        transition-duration: var(--chakra-transition-duration-normal);
        --close-button-size: 32px;
        font-size: 12px;
        position: relative;
        top: 0;
        right: 0;
        color: var(--chakra-colors-white)
    }
    
    #MSVG_1,
    #MSVG_2,
    #svg_7 {
        display: inline-block
    }

    #HEADER_3 {
        
        -webkit-user-select: none; /* Safari */        
-moz-user-select: none; /* Firefox */
-ms-user-select: none; /* IE10+/Edge */
user-select: none; /* Standard */
    }
    
    #DIV_13,
    #FOOTER_27,
    #HEADER_3 {
        inline-size: 482px;
        padding-inline-end: 24px;
        padding-inline-start: 24px;
        width: 482px
    }
    
    #DIV_10,
    #DIV_9 {
        inline-size: 32px;
        width: 32px
    }
    
    #DIV_10,
    #DIV_4,
    #DIV_9 {
        block-size: 32px;
        height: 32px
    }
    
    #DIV_15,
    #DIV_21 {
        height: 60px;
        min-inline-size: 40px;
        min-width: 40px;
        padding-block-start: 30px;
        padding-inline-end: 16px;
        padding-inline-start: 16px;
        perspective-origin: 217px 30px;
        transform-origin: 217px 30px;
        vertical-align: middle;
        background: rgba(0, 0, 0, .48);
        inline-size: 434px;
        width: 434px;
    }
    
    #DIV_17,
    #DIV_18,
    #DIV_20,
    #DIV_23,
    #DIV_24,
    #DIV_26,
    #P_19,
    #P_25 {
        height: 21.59px
    }
    
    #DIV_10,
    #DIV_15,
    #DIV_21 {
        bottom: 0;
        left: 0;
        position: relative;
        right: 0;
        top: 0;
        transition: background-color .2s ease 0s, border-color .2s ease 0s, color .2s ease 0s, fill .2s ease 0s, stroke .2s ease 0s, opacity .2s ease 0s, box-shadow .2s ease 0s, transform .2s ease 0s;
        outline-offset: 2px
    }
    
    #MSVG_1 {
        font-feature-settings: "kern";
        --removed-body-scroll-bar-size: 17px;
        font-weight: var(--chakra-fontWeights-semibold);
        font-size: 18px;
        border-style: solid;
        box-sizing: border-box;
        border-color: var(--chakra-colors-whiteAlpha-300);
        width: 1rem;
        height: 1rem;
        line-height: 1em;
        flex-shrink: 0;
        color: var(--chakra-colors-white);
        vertical-align: middle;
        margin-bottom: var(.25rem);
        margin-left: var(.5rem)
    }
    
    #MSVG_2 {
        font-feature-settings: "kern";
        --removed-body-scroll-bar-size: 17px;
        font-weight: var(--chakra-fontWeights-semibold);
        --close-button-size: 32px;
        font-size: 12px;
        border-style: solid;
        box-sizing: border-box;
        border-color: var(--chakra-colors-whiteAlpha-300);
        width: 1em;
        height: 1em;
        line-height: 1em;
        flex-shrink: 0;
        color: currentcolor;
        vertical-align: middle
    }
    
    #DIV_1,
    #DIV_14:after,
    #DIV_14:before,
    #DIV_1:after,
    #DIV_1:before,
    #DIV_28:after,
    #DIV_28:before,
    #FOOTER_27:after,
    #FOOTER_27:before,
    #SECTION_2,
    #SECTION_2:after,
    #SECTION_2:before {
        caret-color: rgba(255, 255, 255, .92);
        color: rgba(255, 255, 255, .92);
        column-rule-color: rgba(255, 255, 255, .92);
        text-decoration: none solid rgba(255, 255, 255, .92);
        text-emphasis-color: rgba(255, 255, 255, .92);
        font: 16px/24px Raleway, Arial, Helvetica, sans-serif;
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        overflow-wrap: break-word;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%
    }
    
    
    #DIV_14:after,
    #DIV_14:before,
    #DIV_1:after,
    #DIV_1:before,
    #DIV_28:after,
    #DIV_28:before,
    #FOOTER_27:after,
    #FOOTER_27:before,
    #SECTION_2:after,
    #SECTION_2:before {
        display: block;
        border: 0 solid rgba(255, 255, 255, .16);
        outline: rgba(255, 255, 255, .92) 0
    }
    
    #SECTION_2 {
        block-size: 334px;
        border-end-end-radius: 6px;
        border-end-start-radius: 6px;
        border-start-end-radius: 6px;
        border-start-start-radius: 6px;
        bottom: 0;
        box-shadow: rgba(0, 0, 0, .1) 0 0 0 1px, rgba(0, 0, 0, .2) 0 5px 10px 0, rgba(0, 0, 0, .4) 0 15px 40px 0;
        height: 334px;
        inline-size: 512px;
        margin-block-end: 60px;
        margin-block-start: 60px;
        max-inline-size: 512px;
        max-width: 512px;
        min-block-size: auto;
        min-height: auto;
        min-inline-size: auto;
        min-width: auto;
        outline-offset: 2px;
        padding-inline-end: 15px;
        padding-inline-start: 15px;
        perspective-origin: 256px 167px;
        position: relative;
        transform-origin: 256px 167px;
        width: 512px;
        z-index: 1400;
        border: 0 solid rgba(255, 255, 255, .16);
        border-radius: 6px;
        flex-flow: column nowrap;
        outline: transparent solid 2px;
        padding: 0 15px
    }
    
    #DIV_4,
    #DIV_4:after,
    #DIV_4:before,
    #DIV_5,
    #DIV_5:after,
    #DIV_5:before,
    #DIV_9,
    #DIV_9:after,
    #DIV_9:before,
    #HEADER_3,
    #HEADER_3:after,
    #HEADER_3:before {
        caret-color: rgba(255, 255, 255, .92);
        color: rgba(255, 255, 255, .92);
        column-rule-color: rgba(255, 255, 255, .92);
        text-decoration: none solid rgba(255, 255, 255, .92);
        text-emphasis-color: rgba(255, 255, 255, .92);
        font: 600 20px/30px Raleway, Arial, Helvetica, sans-serif;
        outline: rgba(255, 255, 255, .92) 0
    }
    
    #HEADER_3 {
        block-size: 78px;
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        height: 78px;
        min-block-size: auto;
        min-height: auto;
        min-inline-size: auto;
        min-width: auto;
        overflow-wrap: break-word;
        padding-block-end: 16px;
        padding-block-start: 30px;
        perspective-origin: 241px 39px;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        transform-origin: 241px 39px;
        border: 0 solid rgba(255, 255, 255, .16);
        flex: 0 1 0%;
        padding: 30px 24px 16px
    }
    
    #DIV_5:after,
    #DIV_5:before,
    #DIV_9:after,
    #DIV_9:before,
    #HEADER_3:after,
    #HEADER_3:before {
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        overflow-wrap: break-word;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        border: 0 solid rgba(255, 255, 255, .16)
    }
    
    #DIV_4 {
        align-items: center;
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        inline-size: 434px;
        overflow-wrap: break-word;
        perspective-origin: 217px 16px;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        transform-origin: 217px 16px;
        width: 434px;
        border: 0 solid rgba(255, 255, 255, .16)
    }
    
    #DIV_4:after,
    #DIV_4:before {
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        display: block;
        overflow-wrap: break-word;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        border: 0 solid rgba(255, 255, 255, .16)
    }
    
    #DIV_5 {
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        height: 27px;
        min-block-size: auto;
        min-height: auto;
        min-inline-size: auto;
        min-width: auto;
        overflow-wrap: break-word;
        perspective-origin: 201px 13.5px;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        transform-origin: 201px 13.5px;
        width: 402px;
        border: 0 solid rgba(255, 255, 255, .16);
        flex: 1 1 auto
    }
    
    #P_6,
    #P_6:after,
    #P_6:before {
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        caret-color: #fff;
        color: #fff;
        column-rule-color: #fff;
        overflow-wrap: break-word;
        text-decoration: none solid #fff;
        text-emphasis-color: #fff;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        font: 600 18px/27px Raleway, Arial, Helvetica, sans-serif
    }
    
    #P_6 {
        height: 27px;
        margin-block-end: 0;
        margin-block-start: 0;
        perspective-origin: 201px 13.5px;
        transform-origin: 201px 13.5px;
        width: 402px;
        border: 0 solid rgba(255, 255, 255, .16);
        margin: 0;
        outline: #fff 0
    }
    
    #P_6:after,
    #P_6:before {
        border: 0 solid rgba(255, 255, 255, .16);
        outline: #fff 0
    }
    
    #path_8,
    #path_8:after,
    #path_8:before,
    #svg_7,
    #svg_7:after,
    #svg_7:before {
        caret-color: #fff;
        color: #fff;
        column-rule-color: #fff;
        text-decoration: none solid #fff;
        text-emphasis-color: #fff;
        font: 600 18px/18px Raleway, Arial, Helvetica, sans-serif;
        outline: #fff 0;
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        overflow-wrap: break-word;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%
    }
    
    #svg_7 {
        block-size: 16px;
        height: 16px;
        inline-size: 16px;
        margin-block-end: 4px;
        margin-inline-start: 8px;
        perspective-origin: 8px 8px;
        transform-origin: 8px 8px;
        vertical-align: middle;
        width: 16px;
        border: 0 solid rgba(255, 255, 255, .16);
        flex: 0 0 auto;
        margin: 0 0 4px 8px;
        overflow: hidden
    }
    
    #svg_7:after,
    #svg_7:before {
        border: 0 solid rgba(255, 255, 255, .16)
    }
    
    #path_8 {
        d: path("M 12 0 A 12 12 0 1 0 24 12 A 12.013 12.013 0 0 0 12 0 Z M 12.25 5 A 1.5 1.5 0 1 1 10.75 6.5 A 1.5 1.5 0 0 1 12.25 5 Z M 14.5 18.5 H 10.5 A 1 1 0 0 1 10.5 16.5 H 11.25 A 0.25 0.25 0 0 0 11.5 16.25 V 11.75 A 0.25 0.25 0 0 0 11.25 11.5 H 10.5 A 1 1 0 0 1 10.5 9.5 H 11.5 A 2 2 0 0 1 13.5 11.5 V 16.25 A 0.25 0.25 0 0 0 13.75 16.5 H 14.5 A 1 1 0 1 1 14.5 18.5 Z");
        fill: #fff;
        perspective-origin: 0 0;
        border: 0 solid rgba(255, 255, 255, .16)
    }
    
    #path_8:after,
    #path_8:before {
        fill: #fff;
        border: 0 solid rgba(255, 255, 255, .16)
    }
    
    #DIV_9 {
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        min-block-size: auto;
        min-height: auto;
        min-inline-size: auto;
        min-width: auto;
        overflow-wrap: break-word;
        perspective-origin: 16px 16px;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        transform-origin: 16px 16px;
        border: 0 solid rgba(255, 255, 255, .16)
    }
    
    #DIV_10,
    #DIV_10:after,
    #DIV_10:before {
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        caret-color: #fff;
        color: #fff;
        column-rule-color: #fff;
        overflow-wrap: break-word;
        text-decoration: none solid #fff;
        text-emphasis-color: #fff;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        font: 600 12px/18px Raleway, Arial, Helvetica, sans-serif
    }
    
    #DIV_10 {
        align-items: center;
        border-end-end-radius: 6px;
        border-end-start-radius: 6px;
        border-start-end-radius: 6px;
        border-start-start-radius: 6px;
        display: flex;
        justify-content: center;
        perspective-origin: 16px 16px;
        transform-origin: 16px 16px;
        border: 0 solid rgba(255, 255, 255, .16);
        border-radius: 6px;
        flex: 0 0 auto;
        outline: transparent solid 2px
    }
    
    #DIV_10:after,
    #DIV_10:before {
        display: block;
        border: 0 solid rgba(255, 255, 255, .16);
        outline: #fff 0
    }
    
    #path_12,
    #path_12:after,
    #path_12:before,
    #svg_11,
    #svg_11:after,
    #svg_11:before {
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        caret-color: #fff;
        color: #fff;
        column-rule-color: #fff;
        overflow-wrap: break-word;
        text-decoration: none solid #fff;
        text-emphasis-color: #fff;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        font: 600 12px/12px Raleway, Arial, Helvetica, sans-serif;
        outline: #fff 0
    }
    
    #svg_11 {
        block-size: 12px;
        display: block;
        height: 12px;
        inline-size: 12px;
        min-block-size: auto;
        min-height: auto;
        min-inline-size: auto;
        min-width: auto;
        perspective-origin: 6px 6px;
        transform-origin: 6px 6px;
        vertical-align: middle;
        width: 12px;
        border: 0 solid rgba(255, 255, 255, .16);
        flex: 0 0 auto;
        overflow: hidden
    }
    
    #svg_11:after,
    #svg_11:before {
        border: 0 solid rgba(255, 255, 255, .16)
    }
    
    #path_12 {
        d: path("M 0.439 21.44 A 1.5 1.5 0 0 0 2.561 23.561 L 11.823 14.3 A 0.25 0.25 0 0 1 12.177 14.3 L 21.439 23.563 A 1.5 1.5 0 1 0 23.561 21.442 L 14.3 12.177 A 0.25 0.25 0 0 1 14.3 11.823 L 23.563 2.561 A 1.5 1.5 0 0 0 21.439 0.44 L 12.177 9.7 A 0.25 0.25 0 0 1 11.823 9.7 L 2.561 0.44 A 1.5 1.5 0 0 0 0.439 2.561 L 9.7 11.823 A 0.25 0.25 0 0 1 9.7 12.177 Z");
        fill: #fff;
        perspective-origin: 0 0;
        border: 0 solid rgba(255, 255, 255, .16)
    }
    
    #path_12:after,
    #path_12:before {
        fill: #fff;
        border: 0 solid rgba(255, 255, 255, .16)
    }
    
    #DIV_13,
    #DIV_13:after,
    #DIV_13:before,
    #DIV_14,
    #DIV_29:after,
    #DIV_29:before,
    #DIV_31:after,
    #DIV_31:before {
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        caret-color: rgba(255, 255, 255, .92);
        color: rgba(255, 255, 255, .92);
        column-rule-color: rgba(255, 255, 255, .92);
        overflow-wrap: break-word;
        text-decoration: none solid rgba(255, 255, 255, .92);
        text-emphasis-color: rgba(255, 255, 255, .92);
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        font: 16px/24px Raleway, Arial, Helvetica, sans-serif;
        outline: rgba(255, 255, 255, .92) 0
    }
    
    #DIV_13 {
        block-size: 151px;
        height: 151px;
        min-block-size: auto;
        min-height: auto;
        min-inline-size: auto;
        min-width: auto;
        padding-block-end: 8px;
        padding-block-start: 8px;
        perspective-origin: 241px 75.5px;
        transform-origin: 241px 75.5px;
        border: 0 solid rgba(255, 255, 255, .16);
        flex: 1 1 0%;
        padding: 8px 24px
    }
    
    #DIV_13:after,
    #DIV_13:before,
    #DIV_29:after,
    #DIV_29:before,
    #DIV_31:after,
    #DIV_31:before {
        border: 0 solid rgba(255, 255, 255, .16)
    }
    
    #DIV_14 {
        align-items: center;
        block-size: 135px;
        display: flex;
        height: 135px;
        inline-size: 434px;
        perspective-origin: 217px 67.5px;
        transform-origin: 217px 67.5px;
        width: 434px;
        border: 0 solid rgba(255, 255, 255, .16);
        flex-flow: column nowrap
    }
    
    #DIV_15,
    #DIV_15:after,
    #DIV_15:before,
    #DIV_16,
    #DIV_16:after,
    #DIV_16:before,
    #DIV_17,
    #DIV_17:after,
    #DIV_17:before,
    #DIV_18,
    #DIV_18:after,
    #DIV_18:before,
    #DIV_20:after,
    #DIV_20:before,
    #DIV_21:after,
    #DIV_21:before,
    #DIV_22,
    #DIV_22:after,
    #DIV_22:before,
    #DIV_23,
    #DIV_23:after,
    #DIV_23:before,
    #DIV_24:after,
    #DIV_24:before,
    #DIV_26:after,
    #DIV_26:before {
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        caret-color: #fff;
        color: #fff;
        column-rule-color: #fff;
        overflow-wrap: break-word;
        text-decoration: none solid #fff;
        text-emphasis-color: #fff;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        user-select: none;
        white-space: nowrap;
        font: 600 16px/19.2px Raleway, Arial, Helvetica, sans-serif
    }
    
    #DIV_15 {
        align-items: center;
        block-size: 60px;
        border-end-end-radius: 6px;
        border-end-start-radius: 6px;
        border-start-end-radius: 6px;
        border-start-start-radius: 6px;
        display: flex;
        justify-content: center;
        min-block-size: auto;
        min-height: auto;
        padding-block-end: 30px;
        border: 0 solid rgba(255, 255, 255, .16);
        border-radius: 6px;
        outline: transparent solid 2px;
        padding: 30px 16px
    }
    
    #DIV_15:after,
    #DIV_15:before,
    #DIV_16:after,
    #DIV_16:before,
    #DIV_21:after,
    #DIV_21:before,
    #DIV_22:after,
    #DIV_22:before {
        display: block;
        border: 0 solid rgba(255, 255, 255, .16);
        outline: #fff 0
    }
    
    #DIV_16,
    #DIV_22 {
        block-size: 21.59px;
        display: flex;
        height: 21.59px;
        min-block-size: auto;
        min-height: auto;
        min-inline-size: auto;
        min-width: auto;
        perspective-origin: 201px 10.8px;
        transform-origin: 201px 10.8px;
        width: 402px;
        border: 0 solid rgba(255, 255, 255, .16);
        flex: 1 1 0%;
        outline: #fff 0
    }
    
    #DIV_21,
    #FOOTER_27 {
        align-items: center;
        display: flex
    }
    
    #DIV_17,
    #DIV_23 {
        block-size: 21.59px;
        inline-size: 0;
        margin-inline-end: 8px;
        min-block-size: auto;
        min-height: auto;
        min-inline-size: auto;
        transform-origin: 0 10.8px;
        width: 0;
        border: 0 solid rgba(255, 255, 255, .16);
        margin: 0 8px 0 0;
        outline: #fff 0
    }
    
    #DIV_17:after,
    #DIV_17:before,
    #DIV_18:after,
    #DIV_18:before,
    #DIV_20:after,
    #DIV_20:before,
    #DIV_23:after,
    #DIV_23:before,
    #DIV_24:after,
    #DIV_24:before,
    #DIV_26:after,
    #DIV_26:before {
        border: 0 solid rgba(255, 255, 255, .16);
        outline: #fff 0
    }
    
    #DIV_18 {
        block-size: 21.59px;
        inline-size: 85.97px;
        margin-inline-end: 308.03px;
        min-block-size: auto;
        min-height: auto;
        min-inline-size: auto;
        min-width: auto;
        perspective-origin: 42.98px 10.8px;
        transform-origin: 42.98px 10.8px;
        width: 85.97px;
        border: 0 solid rgba(255, 255, 255, .16);
        margin: 0 308.03px 0 0;
        outline: #fff 0
    }
    
    #P_19,
    #P_19:after,
    #P_19:before,
    #P_25:after,
    #P_25:before {
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        caret-color: #fff;
        color: #fff;
        column-rule-color: #fff;
        overflow-wrap: break-word;
        text-decoration: none solid #fff;
        text-emphasis-color: #fff;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        user-select: none;
        white-space: nowrap;
        font: 600 18px/21.6px Raleway, Arial, Helvetica, sans-serif;
        outline: #fff 0
    }
    
    #P_19 {
        block-size: 21.59px;
        inline-size: 85.97px;
        margin-block-end: 0;
        margin-block-start: 0;
        perspective-origin: 42.98px 10.8px;
        transform-origin: 42.98px 10.8px;
        width: 85.97px;
        border: 0 solid rgba(255, 255, 255, .16);
        margin: 0
    }
    
    #P_19:after,
    #P_19:before,
    #P_25:after,
    #P_25:before {
        border: 0 solid rgba(255, 255, 255, .16)
    }
    
    #DIV_20,
    #DIV_21,
    #DIV_24,
    #DIV_26 {
        min-block-size: auto;
        min-height: auto;
        font: 600 16px/19.2px Raleway, Arial, Helvetica, sans-serif;
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        caret-color: #fff;
        color: #fff;
        column-rule-color: #fff;
        overflow-wrap: break-word;
        text-decoration: none solid #fff;
        text-emphasis-color: #fff;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        user-select: none;
        white-space: nowrap
    }
    
    #DIV_20,
    #DIV_26 {
        block-size: 21.59px;
        inline-size: 0;
        min-inline-size: auto;
        transform-origin: 0 10.8px;
        width: 0;
        border: 0 solid rgba(255, 255, 255, .16);
        outline: #fff 0
    }
    
    #DIV_21 {
        block-size: 60px;
        border-end-end-radius: 6px;
        border-end-start-radius: 6px;
        border-start-end-radius: 6px;
        border-start-start-radius: 6px;
        justify-content: center;
        margin-block-start: 15px;
        padding-block-end: 30px;
        border: 0 solid rgba(255, 255, 255, .16);
        border-radius: 6px;
        margin: 15px 0 0;
        outline: transparent solid 2px;
        padding: 30px 16px
    }
    
    #DIV_24 {
        block-size: 21.59px;
        inline-size: 161.28px;
        margin-inline-end: 232.72px;
        min-inline-size: auto;
        min-width: auto;
        perspective-origin: 80.64px 10.8px;
        transform-origin: 80.64px 10.8px;
        width: 161.28px;
        border: 0 solid rgba(255, 255, 255, .16);
        margin: 0 232.72px 0 0;
        outline: #fff 0
    }
    
    #P_25 {
        block-size: 21.59px;
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        caret-color: #fff;
        color: #fff;
        column-rule-color: #fff;
        inline-size: 161.28px;
        margin-block-end: 0;
        margin-block-start: 0;
        overflow-wrap: break-word;
        perspective-origin: 80.64px 10.8px;
        text-decoration: none solid #fff;
        text-emphasis-color: #fff;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        transform-origin: 80.64px 10.8px;
        user-select: none;
        white-space: nowrap;
        width: 161.28px;
        border: 0 solid rgba(255, 255, 255, .16);
        font: 600 18px/21.6px Raleway, Arial, Helvetica, sans-serif;
        margin: 0;
        outline: #fff 0
    }
    
    #DIV_28,
    #DIV_29,
    #FOOTER_27 {
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        overflow-wrap: break-word;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        font: 16px/24px Raleway, Arial, Helvetica, sans-serif;
        caret-color: rgba(255, 255, 255, .92);
        color: rgba(255, 255, 255, .92);
        column-rule-color: rgba(255, 255, 255, .92);
        min-block-size: auto;
        min-height: auto;
        min-inline-size: auto;
        min-width: auto;
        text-decoration: none solid rgba(255, 255, 255, .92);
        text-emphasis-color: rgba(255, 255, 255, .92);
        outline: rgba(255, 255, 255, .92) 0
    }
    
    #FOOTER_27 {
        block-size: 105px;
        height: 105px;
        justify-content: flex-end;
        padding-block-end: 30px;
        padding-block-start: 16px;
        perspective-origin: 241px 52.5px;
        transform-origin: 241px 52.5px;
        border: 0 solid rgba(255, 255, 255, .16);
        padding: 16px 24px 30px
    }
    
    #DIV_28 {
        align-items: center;
        block-size: 59px;
        display: flex;
        height: 59px;
        inline-size: 434px;
        justify-content: center;
        perspective-origin: 217px 29.5px;
        transform-origin: 217px 29.5px;
        width: 434px;
        border: 0 solid rgba(255, 255, 255, .16);
        flex: 1 1 0%;
        flex-flow: column nowrap
    }
    
    #DIV_29 {
        height: 27px;
        inline-size: 126.81px;
        margin-block-end: 8px;
        perspective-origin: 63.41px 13.5px;
        transform-origin: 63.41px 13.5px;
        width: 126.81px;
        border: 0 solid rgba(255, 255, 255, .16);
        margin: 0 0 8px
    }
    
    #P_30,
    #P_30:after,
    #P_30:before {
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        overflow-wrap: break-word;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        font: 18px/27px Raleway, Arial, Helvetica, sans-serif;
        caret-color: #fff;
        color: #fff;
        column-rule-color: #fff;
        text-decoration: none solid #fff;
        text-emphasis-color: #fff;
        outline: #fff 0
    }
    
    #P_30 {
        height: 27px;
        inline-size: 126.81px;
        margin-block-end: 0;
        margin-block-start: 0;
        perspective-origin: 63.41px 13.5px;
        transform-origin: 63.41px 13.5px;
        width: 126.81px;
        border: 0 solid rgba(255, 255, 255, .16);
        margin: 0
    }
    
    #P_30:after,
    #P_30:before {
        border: 0 solid rgba(255, 255, 255, .16)
    }
    
    #A_32,
    #A_32:after,
    #A_32:before,
    #DIV_31 {
        border-block-end-color: rgba(255, 255, 255, .16);
        border-block-end-style: solid;
        border-block-start-color: rgba(255, 255, 255, .16);
        border-block-start-style: solid;
        border-inline-end-color: rgba(255, 255, 255, .16);
        border-inline-end-style: solid;
        border-inline-start-color: rgba(255, 255, 255, .16);
        border-inline-start-style: solid;
        box-sizing: border-box;
        overflow-wrap: break-word;
        text-rendering: optimizelegibility;
        text-size-adjust: 100%;
        font: 16px/24px Raleway, Arial, Helvetica, sans-serif
    }
    
    #DIV_31 {
        block-size: 24px;
        caret-color: rgba(255, 255, 255, .92);
        color: rgba(255, 255, 255, .92);
        column-rule-color: rgba(255, 255, 255, .92);
        height: 24px;
        inline-size: 258.42px;
        min-block-size: auto;
        min-height: auto;
        min-inline-size: auto;
        min-width: auto;
        perspective-origin: 129.2px 12px;
        text-decoration: none solid rgba(255, 255, 255, .92);
        text-emphasis-color: rgba(255, 255, 255, .92);
        transform-origin: 129.21px 12px;
        width: 258.42px;
        border: 0 solid rgba(255, 255, 255, .16);
        outline: rgba(255, 255, 255, .92) 0
    }
    
    #A_32 {
        caret-color: #fff;
        color: #fff;
        column-rule-color: #fff;
        outline-offset: 2px;
        perspective-origin: 0 0;
        text-decoration: none solid #fff;
        text-emphasis-color: #fff;
        text-transform: uppercase;
        white-space: nowrap;
        border: 0 solid rgba(255, 255, 255, .16);
        outline: transparent solid 2px;
        transition: background-color .15s cubic-bezier(0, 0, .2, 1) 0s, border-color .15s cubic-bezier(0, 0, .2, 1) 0s, color .15s cubic-bezier(0, 0, .2, 1) 0s, fill .15s cubic-bezier(0, 0, .2, 1) 0s, stroke .15s cubic-bezier(0, 0, .2, 1) 0s, opacity .15s cubic-bezier(0, 0, .2, 1) 0s, box-shadow .15s cubic-bezier(0, 0, .2, 1) 0s, transform .15s cubic-bezier(0, 0, .2, 1) 0s
    }

    #P_6 {
        width: 100% !important;
    }
    
    #A_32:after,
    #A_32:before {
        caret-color: #fff;
        color: #fff;
        column-rule-color: #fff;
        text-decoration: none solid #fff;
        text-emphasis-color: #fff;
        text-transform: uppercase;
        white-space: nowrap;
        border: 0 solid rgba(255, 255, 255, .16);
        outline: #fff 0
    }
    </style>`);
};

export default {
    async mintButtonOnClick() {
        chosenWallet = 'metamask';
        if (!await verifyWalletConnection()) {
            return;
        }
        console.log("Works");
        await fetchContractState();
        await updateContractState();
    
    },
    initialize
}
